export const iconsArray = [
    "search",
    "home",
    "account_circle",
    "settings",
    "done",
    "info",
    "check_circle",
    "delete",
    "shopping_cart",
    "visibility",
    "favorite",
    "logout",
    "description",
    "favorite_border",
    "lock",
    "schedule",
    "language",
    "face",
    "help_outline",
    "manage_accounts",
    "fingerprint",
    "filter_alt",
    "event",
    "verified",
    "thumb_up",
    "dashboard",
    "login",
    "calendar_today",
    "visibility_off",
    "list",
    "check_circle_outline",
    "highlight_off",
    "date_range",
    "help",
    "question_answer",
    "task_alt",
    "paid",
    "article",
    "lightbulb",
    "shopping_bag",
    "open_in_new",
    "perm_identity",
    "trending_up",
    "history",
    "credit_card",
    "account_balance",
    "delete_outline",
    "report_problem",
    "fact_check",
    "assignment",
    "verified_user",
    "arrow_right_alt",
    "star_rate",
    "account_balance_wallet",
    "analytics",
    "autorenew",
    "work",
    "build",
    "print",
    "view_list",
    "store",
    "today",
    "delete_forever",
    "admin_panel_settings",
    "lock_open",
    "savings",
    "room",
    "code",
    "grade",
    "receipt",
    "watch_later",
    "update",
    "add_shopping_cart",
    "contact_support",
    "power_settings_new",
    "pets",
    "done_all",
    "explore",
    "bookmark",
    "bookmark_border",
    "reorder",
    "note_add",
    "account_box",
    "shopping_basket",
    "pending_actions",
    "drag_indicator",
    "payment",
    "menu",
    "launch",
    "supervisor_account",
    "touch_app",
    "zoom_in",
    "pending",
    "assessment",
    "thumb_up_off_alt",
    "open_in_full",
    "done_outline",
    "leaderboard",
    "exit_to_app",
    "preview",
    "assignment_ind",
    "card_giftcard",
    "view_in_ar",
    "work_outline",
    "calendar_month",
    "feedback",
    "timeline",
    "published_with_changes",
    "dns",
    "swap_horiz",
    "assignment_turned_in",
    "sync_alt",
    "book",
    "flight_takeoff",
    "stars",
    "label",
    "pan_tool",
    "bug_report",
    "contact_page",
    "android",
    "gavel",
    "alarm",
    "translate",
    "cached",
    "accessibility",
    "supervised_user_circle",
    "space_dashboard",
    "edit_calendar",
    "minimize",
    "extension",
    "get_app",
    "record_voice_over",
    "add_task",
    "trending_flat",
    "hourglass_empty",
    "accessibility_new",
    "thumb_down",
    "help_center",
    "tips_and_updates",
    "flutter_dash",
    "sticky_note_2",
    "rule",
    "support",
    "dashboard_customize",
    "source",
    "find_in_page",
    "close_fullscreen",
    "settings_applications",
    "view_headline",
    "announcement",
    "redeem",
    "loyalty",
    "group_work",
    "swap_vert",
    "ads_click",
    "sensors",
    "restore",
    "euro_symbol",
    "compare_arrows",
    "dangerous",
    "nightlight_round",
    "privacy_tip",
    "subject",
    "grading",
    "track_changes",
    "https",
    "copyright",
    "disabled_by_default",
    "table_view",
    "arrow_circle_up",
    "arrow_circle_right",
    "toc",
    "bookmarks",
    "api",
    "query_builder",
    "build_circle",
    "perm_media",
    "book_online",
    "input",
    "rocket_launch",
    "zoom_out",
    "question_mark",
    "backup",
    "perm_contact_calendar",
    "open_with",
    "3d_rotation",
    "settings_phone",
    "circle_notifications",
    "view_module",
    "arrow_circle_down",
    "speaker_notes",
    "card_membership",
    "label_important",
    "perm_phone_msg",
    "file_present",
    "swipe",
    "wysiwyg",
    "pageview",
    "integration_instructions",
    "upgrade",
    "trending_down",
    "change_history",
    "accessible",
    "class",
    "g_translate",
    "settings_accessibility",
    "production_quantity_limits",
    "offline_bolt",
    "expand",
    "model_training",
    "aspect_ratio",
    "calendar_view_month",
    "donut_large",
    "settings_backup_restore",
    "segment",
    "maximize",
    "schedule_send",
    "view_column",
    "bookmark_add",
    "alarm_on",
    "thumbs_up_down",
    "thumb_down_off_alt",
    "view_agenda",
    "arrow_circle_left",
    "settings_ethernet",
    "theaters",
    "important_devices",
    "invert_colors",
    "unpublished",
    "percent",
    "open_in_browser",
    "opacity",
    "commute",
    "addchart",
    "youtube_searched_for",
    "no_accounts",
    "history_toggle_off",
    "tour",
    "view_week",
    "settings_input_antenna",
    "shop",
    "system_update_alt",
    "mark_as_unread",
    "turned_in",
    "bookmark_added",
    "hide_source",
    "plagiarism",
    "flight_land",
    "search_off",
    "contactless",
    "saved_search",
    "not_started",
    "donut_small",
    "assignment_late",
    "currency_exchange",
    "highlight_alt",
    "anchor",
    "view_carousel",
    "settings_input_component",
    "mediation",
    "turned_in_not",
    "fit_screen",
    "settings_remote",
    "toll",
    "edit_off",
    "flaky",
    "remove_shopping_cart",
    "view_quilt",
    "assignment_return",
    "hourglass_full",
    "all_inbox",
    "lock_clock",
    "settings_voice",
    "online_prediction",
    "pregnant_woman",
    "swap_horizontal_circle",
    "event_seat",
    "camera_enhance",
    "next_plan",
    "view_sidebar",
    "restore_from_trash",
    "markunread_mailbox",
    "hotel_class",
    "accessible_forward",
    "vertical_split",
    "calendar_view_week",
    "tab",
    "dynamic_form",
    "add_to_drive",
    "settings_power",
    "data_exploration",
    "view_stream",
    "remove_done",
    "smart_button",
    "card_travel",
    "request_page",
    "try",
    "filter_alt_off",
    "offline_pin",
    "balance",
    "outbox",
    "calendar_view_day",
    "rowing",
    "outlet",
    "find_replace",
    "compress",
    "shopping_cart_checkout",
    "chrome_reader_mode",
    "settings_brightness",
    "alarm_add",
    "http",
    "assignment_returned",
    "play_for_work",
    "spellcheck",
    "gif",
    "token",
    "backup_table",
    "restore_page",
    "credit_card_off",
    "wifi_protected_setup",
    "settings_overscan",
    "rocket",
    "quickreply",
    "settings_input_composite",
    "new_label",
    "comment_bank",
    "view_day",
    "polymer",
    "generating_tokens",
    "swap_vertical_circle",
    "line_weight",
    "fax",
    "outbound",
    "cancel_schedule_send",
    "horizontal_split",
    "batch_prediction",
    "send_and_archive",
    "lock_reset",
    "picture_in_picture",
    "code_off",
    "settings_bluetooth",
    "bookmark_remove",
    "free_cancellation",
    "terminal",
    "flip_to_front",
    "switch_access_shortcut",
    "disabled_visible",
    "shop_two",
    "density_medium",
    "gif_box",
    "eject",
    "speaker_notes_off",
    "perm_data_setting",
    "perm_scan_wifi",
    "settings_input_hdmi",
    "alarm_off",
    "settings_cell",
    "hourglass_disabled",
    "app_blocking",
    "satellite_alt",
    "sensors_off",
    "work_off",
    "line_style",
    "view_timeline",
    "perm_device_information",
    "picture_in_picture_alt",
    "subtitles_off",
    "add_card",
    "switch_access_shortcut_add",
    "update_disabled",
    "settings_input_svideo",
    "webhook",
    "html",
    "voice_over_off",
    "123",
    "flip_to_back",
    "assured_workload",
    "view_array",
    "open_in_new_off",
    "all_out",
    "output",
    "event_repeat",
    "display_settings",
    "label_off",
    "rounded_corner",
    "private_connectivity",
    "swipe_left",
    "tab_unselected",
    "text_rotate_vertical",
    "shop_2",
    "explore_off",
    "app_shortcut",
    "javascript",
    "text_rotation_none",
    "join_full",
    "not_accessible",
    "swipe_right",
    "noise_control_off",
    "pin_invoke",
    "install_desktop",
    "perm_camera_mic",
    "extension_off",
    "abc",
    "swipe_up",
    "join_inner",
    "pin_end",
    "pan_tool_alt",
    "density_small",
    "text_rotate_up",
    "install_mobile",
    "work_history",
    "data_thresholding",
    "text_rotation_down",
    "text_rotation_angledown",
    "swipe_down",
    "text_rotation_angleup",
    "commit",
    "manage_history",
    "lightbulb_circle",
    "css",
    "join_left",
    "view_kanban",
    "pinch",
    "swipe_vertical",
    "view_cozy",
    "join_right",
    "swipe_right_alt",
    "view_comfy_alt",
    "swipe_down_alt",
    "view_compact_alt",
    "php",
    "noise_aware",
    "spatial_audio_off",
    "browse_gallery",
    "swipe_up_alt",
    "swipe_left_alt",
    "network_ping",
    "density_large",
    "on_device_training",
    "hls",
    "spatial_tracking",
    "close",
    "person",
    "add",
    "edit",
    "email",
    "file_download",
    "local_shipping",
    "play_arrow",
    "star",
    "warning",
    "attach_money",
    "support_agent",
    "keyboard_arrow_down",
    "light_mode",
    "storefront",
    "feed",
    "sensor_door"
];